"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.operationTypes = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
exports.operationTypes = {
    'create': (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/EntityLog/OperationType:Create', defaultMessage: 'Create' })),
    'update': (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/EntityLog/OperationType:Update', defaultMessage: 'Update' })),
    'delete': (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/EntityLog/OperationType:Delete', defaultMessage: 'Delete' })),
    'activate': (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/EntityLog/OperationType:Activate', defaultMessage: 'Activate' })),
    'deactivate': (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/EntityLog/OperationType:Deactivate', defaultMessage: 'Deactivate' })),
    'cancel': (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/EntityLog/OperationType:Cancel', defaultMessage: 'Cancel' })),
};
//# sourceMappingURL=operationTypes.js.map